export default __webpack_public_path__ + "static/media/image.rukula-pvt-ltd.e568cc61.png";